import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'trim'
})
export class TrimPipe implements PipeTransform {

  transform(value: string): string {
    return value.replace(/\s+/g, ' ').trim();
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/pipes/trim.pipe.ts